module.exports = __webpack_public_path__ + "static/media/legal-jobs.e0820e94.jpg";